import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const config: RouteRecordItem = {
  path: '/config',
  name: 'Config',
  component: LAYOUT,
  redirect: { name: 'ConfigDetail' },
  meta: {
    orderNo: 11,
    icon: 'eos-icons:configuration-file',
    title: t('routes.config.实例配置'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'detail',
      name: 'ConfigDetail',
      component: () => import('@/pages/config/index.vue'),
      meta: {
        title: t('routes.config.实例配置'),
      },
    },
  ],
}

export default config
